import axios from "axios";

const httpClient = axios.create({
  timeout: 15000,
  headers: {
    Accept: "application/json",
  },
});

export default httpClient;
